export const FILE_TYPE_WORKING = 0
export const FILE_TYPE_FINAL = 1
export const FILE_TYPE_DESCRIPTIONAL = 2
export const FILE_TYPE_INFORMATIONAL = 2
